import React from "react";
export const LinkWithTargetAndRel = ({ linkUrl, children, linkOpensInNewTab, className }) => {
    if (!linkUrl) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("a", { className: className, href: linkUrl, target: linkOpensInNewTab ? "_blank" : undefined, rel: linkOpensInNewTab ? "noreferrer" : undefined }, children));
};
